module.exports = __webpack_public_path__ + "assets/img/subtraction_icon.40219de8.svg";